import { render, staticRenderFns } from "./modalIRRF.vue?vue&type=template&id=83e632c8&scoped=true&"
import script from "./modalIRRF.vue?vue&type=script&lang=js&"
export * from "./modalIRRF.vue?vue&type=script&lang=js&"
import style0 from "./modalIRRF.vue?vue&type=style&index=0&id=83e632c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e632c8",
  null
  
)

export default component.exports